import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { usePostAuthorization } from "@sprout/client-components/dist/Post";
import { PostPageToolbar, PostPageToolbarItemNote, PostPageToolbarItemReply, PostPageToolbarItemTodo, PostPageToolbarItemTodoList, PostPageToolbarItemWhen, usePostPageToolbarMenu } from "../PostPageToolbar";
import PostPageViewsPostToolbarMenu from "./PostPageViewsPostToolbarMenu";
const PostPageViewsPostToolbar = (props)=>{
    const { post  } = props;
    usePostPageToolbarMenu(post);
    const authorization = usePostAuthorization(post);
    return /*#__PURE__*/ _jsxs(PostPageToolbar, {
        children: [
            /*#__PURE__*/ _jsx(PostPageToolbarItemNote, {}),
            authorization.addTodo && /*#__PURE__*/ _jsx(PostPageToolbarItemTodo, {}),
            authorization.addTodoList && /*#__PURE__*/ _jsx(PostPageToolbarItemTodoList, {}),
            authorization.schedule && /*#__PURE__*/ _jsx(PostPageToolbarItemWhen, {
                item: post
            }),
            /*#__PURE__*/ _jsx(PostPageToolbarItemReply, {
                itemId: post.id
            }),
            /*#__PURE__*/ _jsx(PostPageViewsPostToolbarMenu, {
                post: post
            })
        ]
    });
};
export default PostPageViewsPostToolbar;
